export default __webpack_public_path__ + "eef593ebff7569f307617c53b8d61a1b.wav";